module.exports = __webpack_public_path__ + "img/last-friend.957d88cf.png";